import React from "react";
import { ThemeBasedColorHeader } from "src/shared/modules/profile/theme/themeCheacker";
import { Order } from "src/shared/types";

interface Props {
    order: Order | null;
    onChangeOrder: () => void;
}

export default function OrderDetailsCard({ order, onChangeOrder }: Props) {
    if (!order) return null;

    // New interface field paths
    const transaction = order.orders?.[0];
    const currentStatus = transaction?.status ?? "";

    const customerName = [
        order.customerDetails?.firstName,
        order.customerDetails?.middleName,
        order.customerDetails?.lastName,
    ]
        .filter(Boolean)
        .join(" ");

    const orderDate = transaction?.orderedOn?.$date
        ? new Date(transaction.orderedOn.$date).toLocaleDateString("en-GB", {
            timeZone: "UTC",
        })
        : "";

    const orderTime = transaction?.orderedOn?.$date
        ? new Date(transaction.orderedOn.$date).toLocaleTimeString("en-GB", {
            timeZone: "UTC",
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        })
        : "";

    return (
        <div className="bg-white rounded shadow">
            <div className={`${ThemeBasedColorHeader()} text-white p-2 rounded-t`}>
                Order Details
            </div>

            <div className="p-2 text-sm space-y-1">
                <div className="flex justify-between">
                    <span>Order Id</span>
                    <span
                        className="flex gap-1 cursor-pointer"
                        onClick={onChangeOrder}
                    >
                        {order.orderId}
                        <p className="text-red-500">X</p>
                    </span>
                </div>

                <div className="flex justify-between">
                    <span>Name</span>
                    <span>{customerName}</span>
                </div>

                <div className="flex justify-between">
                    <span>Status</span>
                    <span className="text-red-500">{currentStatus}</span>
                </div>

                <div className="flex justify-between">
                    <span>Date</span>
                    <span>
                        {orderDate} / {orderTime}
                    </span>
                </div>
            </div>
        </div>
    );
}